
<template>
  <!--编辑app功能-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="actionId"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        <img :style="{width: '30px', height: '30px'}" :src="row.iconUrl" alt="">
      </template>
    </x-tabula>

    <!--添加功能的弹窗-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="submitForm"
      @cancel="visible=false"
      :btnLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
      <x-addEdit
        ref="addEdit"
        formType="modal"
        :initReqHandle="false"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formData="formData"
        :transferVal="transferVal"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      >
        <template slot="transfer" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <transfer ref="transfer"/>
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import {fetchSelect, userRange} from '@/utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
import transfer from '../../views/transfer.vue';
export default {
  mixins: [fetchSelect, addEdit, userRange],
  components: {
    transfer
  },
  name: 'editAppFun',
  data () {
    let decoratorOptions = {
      title: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入应用名称'},
          {min: 2, max: 20, message: '功能名为2-20个字'}
        ]
      },
      uniqueMark: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入功能识别符'},
          {min: 2, max: 20, message: '功能识别符为2-20个字'}
        ]
      },
      icon: {
        rules: [{required: true, message: '请上传图标'}]
      },
      platform: {
        rules: [{required: true, message: '请选择平台'}]
      },
      sort: {rules: []},
      isDefault: {
        valuePropName: 'checked',
        initialValue: false,
        rules: [{required: true, message: '请选择是否默认'}]
      },
      price: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '请输入价格'}]
      },
      scopeType: {
        rules: [{required: true, message: '请选择应用范围'}]
      },
      behaviorType: {
        rules: [{required: true, message: '请选择行为方式'}]
      },
      behaviorParam: {},
      description: {rules: [{min: 2, max: 20, message: '描述信息为2-20个字'}]}
    };
    return {
      modalTitle: undefined,
      scopeType: '',
      scopeArr: [],
      transferVal: '',
      searchList: [],
      tableOptList: [
        { text: '添加功能', icon: 'plus', handle: this.handleOpenModal, permi: ['community:appButton:add'] }
      ],
      rowOptList: [
        { text: '', customRender: true, handle: row => this.statusChange(row), permi: ['community:appButton:status'] },
        { text: '编辑', handle: row => this.toEditFun(row.actionId), permi: ['community:appButton:edit'] },
        { text: '删除', handle: row => this.$refs.table.showDeleteConfirm(row), permi: ['community:appButton:remove'] }
      ],
      columns: [
        { title: '功能名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '功能识别符', dataIndex: 'uniqueMark', align: 'left', width: '' },
        { title: '功能图标', dataIndex: 'iconUrl', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '排序', dataIndex: 'sort', align: 'left', width: '' },
        { title: '应用平台', dataIndex: 'platform', align: 'left', width: '' },
        { title: '默认功能', dataIndex: 'isDefault', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        applicationId: ''
      },
      listApi: {
        url: '/action/list',
        resHandle: this.listResHandle,
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        title: ''
      },
      deleteParam: {
        url: '/action/',
        // param: {pk_key: 'applicationId', pk_val: ''},
        title: '功能',
        key: 'title'
      },

      formData: '',
      visible: false,
      btnLoading: { loading: false },
      addParam: {
        url: '/action',
        reqHandle: this.addReqHandle,
        resHandle: this.addResHandle
      },
      editParam: {
        url: '/action/',
        resHandle: this.editResHandle
      },
      detailParam: {
        url: '/action/',
        resHandle: this.detailResHandle
      },
      formKey: {
        title: '',
        uniqueMark: '',
        icon: '',
        platform: '',
        sort: '',
        isDefault: '',
        price: '',
        scopeType: '',
        behaviorType: '',
        behaviorParam: '',
        description: ''
      },
      formList: [
        {
          label: '功能名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入功能名称',
          props: ['title', decoratorOptions.title]
        },
        {
          label: '功能标识符',
          inputType: 'input',
          options: [],
          placeholder: '请输入功能标识符',
          props: ['uniqueMark', decoratorOptions.uniqueMark]
        },
        {
          label: '图标',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'iconUrl',
            iconName: 'fileName',

            action: this.$store.state.uploadUrl,
            accept: this.$store.state.imgAccept,
            headers: {},
            listType: 'picture',
            uploadType: 4
          },
          props: ['icon', decoratorOptions.icon]
        },
        {
          label: '平台',
          inputType: 'checkboxGroup',
          options: [],
          placeholder: '请选择平台',
          props: ['platform', decoratorOptions.platform]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          placeholder: '请输入排序',
          type: 'number',
          extra: '默认排序：99',
          props: ['sort', decoratorOptions.sort]
        },
        {
          label: '是否默认',
          inputType: 'switch',
          options: [],
          placeholder: '',
          props: ['isDefault', decoratorOptions.isDefault]
        },
        {
          label: '价格',
          inputType: 'input',
          options: [],
          placeholder: '请输入价格',
          props: ['price', decoratorOptions.price]
        },
        {
          label: '应用范围',
          inputType: 'select',
          options: [{ label: '全部用户', value: 0 }, { label: '指定城市', value: 1 }, { label: '指定小区', value: 2 }],
          handle: e => this.handleUserRange(e),
          placeholder: '请选择应用范围',
          props: ['scopeType', decoratorOptions.scopeType]
        },
        {
          isShow: false,
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: true,
          key: 'city',
          props: ['cityScope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          slot: 'transfer',
          isShow: false,
          label: '选择小区',
          inputType: 'text',
          options: [],
          placeholder: '',
          titles: ['小区列表', '已选'],
          key: 'community',
          props: ['communityScope', {
            rules: [{required: true, message: '请选择小区'}]
          }]
        },
        {
          label: '行为方式',
          inputType: 'select',
          options: [],
          placeholder: '请选择行为方式',
          handle: this.actionChange,
          props: ['behaviorType', decoratorOptions.behaviorType]
        },
        {
          label: '行为参数',
          inputType: 'input',
          options: [],
          placeholder: '请输入行为参数',
          props: ['behaviorParam', decoratorOptions.behaviorParam]
        },
        {
          isShow: false,
          label: '小程序原始id',
          inputType: 'input',
          options: [],
          placeholder: '请输入小程序原始id',
          props: ['userName', {
            rules: [
              {required: true, message: '请输入小程序原始id'},
              {pattern: /^[\d\w-]*$/, message: '请输入字母、数字'}
            ]
          }]
        },
        {
          isShow: false,
          label: '小程序路径',
          inputType: 'input',
          options: [],
          placeholder: '请输入小程序路径',
          props: ['path', {
            rules: [{pattern: /^[\d\w-/?=&]*$/, message: '请输入有效的路径'}]
          }]
        },
        {
          isShow: false,
          label: '小程序环境',
          inputType: 'select',
          options: [
            { value: 0, label: '正式版' },
            { value: 1, label: '开发版' },
            { value: 2, label: '体验版' }
          ],
          placeholder: '请选择小程序环境',
          props: ['miniprogramType', {
            initialValue: 1,
            rules: [{required: true, message: '请选择小程序环境'}]
          }]
        },

        {
          label: '描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['description', decoratorOptions.description]
        }
      ]
    };
  },
  created () {
    this.handleQuery();
    let paramArr = [
      // {index: 7, scope: 'formList', query: 'comu_application_scope_type'},
      {index: 10, scope: 'formList', query: 'comu_app_button_behavior_type'}
    ];
    this.dictionarySelect(paramArr);
  },
  methods: {
    submitForm () {
      this.$refs.addEdit.handleSubmit();
    },
    handleQuery () {
      this.routeQuery = this.$route.query.id;
      this.searchParams.applicationId = this.routeQuery;
      let scopeArr = this.getLocal('scopeArray');
      if (scopeArr && scopeArr.length) {
        this.scopeArr = scopeArr;
      }

      let platform = [];
      let query = this.$route.query;
      for (let item in query) {
        if (item === 'android' || item === 'ios') {
          if (query[item] !== '0') {
            let platformObj = { android: '1', ios: '2' }; // Android: 1 iOS: 2
            platform.push({
              label: item,
              value: platformObj[item]
            });
          }
        }
      }
      let range = [];
      this.scopeType = parseInt(query.scopeType);
      if (this.scopeType > 0) {
        this.$store.state.userRange.forEach((el) => {
          if (parseInt(this.scopeType) === el.value) {
            range.push({...el});
          }
        });
      }

      this.formList.forEach((el) => {
        let prop = el.props;
        if (prop && prop[0] === 'scopeType' && this.scopeType > 0) {
          el.options = range; // 根据app应该范围，限制功能范围的下拉列表
        }
        if (prop && prop[0] === 'platform') {
          el.options = platform;
        }
      });
    },
    /** 行为方式 change 事件 */
    actionChange (e) {
      if (e === '3') {
        this.triggerVisible(true);
      } else {
        this.triggerVisible(false);
      }
    },
    detailResHandle (res) {
      if (res.scopeType == 2) {
        setTimeout(() => {
          this.$refs.transfer.setTarget(res.scope.split(','));
        }, 0);
      }
      let values = {};
      for (let item in res) {
        if (this.formKey.hasOwnProperty(item)) {
          values[item] = res[item];
        }
      }
      res.isDefault === 1 ? values.isDefault = true : values.isDefault = false;
      let arr = [];
      (res.android === '1') && arr.push('1'); // Android: 1 iOS: 2
      (res.ios === '1') && arr.push('2');
      values.platform = arr;
      if (res.scope) {
        values.scope = res.scope.split(',');
        this.rangeResVal(values, res);
      }

      if (values.behaviorType === '3') {
        let programParam = JSON.parse(values.behaviorParam);
        values = {...values, ...programParam};
        this.actionChange(values.behaviorType);
      }

      this.handleUserRange(res.scopeType, values);
    },
    editResHandle (res) {
      this.visible = false;
      this.$refs.table.getTableList();
    },
    /* 提交表单前处理数据 */
    addReqHandle (param) {
      let arealist = this.$refs.transfer && this.$refs.transfer.targetKeys;
      if (param.scopeType == 2 && arealist.length == 0) {
        this.$message.error('请选择小区');
        return;
      }
      if (param.scopeType == 2 && arealist.length != 0) {
        param.communityScope = arealist;
      }
      param.applicationId = this.routeQuery;
      param.isDefault = param.isDefault === true ? 1 : 0;
      let platform = param.platform;
      if (platform.length) { // Android: 1 iOS: 2
        platform.forEach((el) => {
          el === '1' && (param.android = '1');
          el === '2' && (param.ios = '1');
        });
        if (!param.hasOwnProperty('ios')) {
          param.ios = '0';
        }
        if (!param.hasOwnProperty('android')) {
          param.android = '0';
        }
      } else {
        param.android = '0';
        param.ios = '0';
      }

      if (param.cityScope) {
        param.scope = param.cityScope = param.cityScope.join(',');
      }
      if (param.communityScope) {
        param.scope = param.communityScope = param.communityScope.join(',');
      }

      if (param.behaviorType === '3') {
        param.behaviorParam = JSON.stringify({
          userName: param.userName,
          path: param.path,
          miniprogramType: param.miniprogramType
        });
      }

      param = this.rangeReqVal(param);
      return param;
    },
    addResHandle (res) {
      this.visible = false;
      this.$refs.table.getTableList();
    },
    /* 进入编辑功能 */
    toEditFun (id) {
      this.handleOpenModal();
      this.modalTitle = '编辑功能';
      this.$nextTick(() => {
        this.$refs.addEdit.routeQuery = id;
        this.$refs.addEdit.getDetail();
      });
    },
    /* 初始化弹窗 */
    handleOpenModal () {
      this.modalTitle = '添加功能';
      this.visible = true;
      this.$nextTick(() => {
        this.triggerVisible(false);
      });

      this.formList.forEach((el, index) => {
        if (el.inputType && el.inputType === 'upload') {
          el.fileList = [];
        }
        let prop = el.props;
        if (prop && prop[0] === 'behaviorType') {
          // this.typeSelect({ index: index, query: 'app_behavior_type_desc' });
        }
      });
    },
    /** 切换是否显示小程序输入框 */
    triggerVisible (isShow) {
      let keyArr = ['userName', 'path', 'miniprogramType'];
      this.formList.forEach((el) => {
        let prop = el.props && el.props[0];
        let isSame = keyArr.some(item => item === prop);
        isSame && (el.isShow = isShow);

        if (prop === 'behaviorParam') {
          isShow ? (el.isShow = false) : (el.isShow = true);
        }
      });
    },
    /* 状态切换 */
    statusChange (row) {
      this.$put({
        url: `/action/changeStatus/${row.actionId}`,
        params: { status: row.status === 1 ? 0 : 1 }
      }).then((res) => {
        this.$message.success('切换成功！');
        this.$refs.table.getTableList();
      });
    },
    /* 处理用户范围 */
    handleUserRange (val, formVals) {
      let userTypeObj = {
        0: { city: false, community: false },
        1: { city: true, community: false },
        2: { city: false, community: true }
      };
      this.handleDynamicForm(val, userTypeObj);

      // 根据上一级目录中的scopeType 来获取不同下拉
      if (parseInt(this.$route.query.scopeType) > 0 && this.scopeArr.length) {
        if (val === 1) { // 城市
          this.formList[8].options = this.scopeArr;
        } else { // 小区
          let arr = [];
          this.scopeArr.forEach((el) => {
            arr.push({key: `${el.value}`, title: el.label});
          });
          this.formList[9].options = arr;
        }
      } else {
        this.regionSelect((data) => {
          this.formList[8].options = data;
        }, 'formLst', '1,2');
        this.communitySelect((data) => {
          let arr = [];
          data.forEach((el) => {
            arr.push({key: `${el.value}`, title: el.label});
          });
          this.formList[9].options = arr;
        });
        this.$get({
          url: '/regions/cityTreeSelect'
        }).then(({data}) => {
          this.formList[8].options = data;
        });
        // if (val === 1) { // 城市
        //   this.regionSelect((data) => {
        //     this.formList[8].options = data;
        //   }, 'formLst', '1,2');
        // } else if (val === 2) { // 小区
        //   this.communitySelect((data) => {
        //     let arr = [];
        //     data.forEach((el) => {
        //       arr.push({key: `${el.value}`, title: el.label});
        //     });
        //     this.formList[9].options = arr;
        //   });
        // }
      }
      if (formVals) {
        this.$nextTick(() => {
          this.$refs.addEdit.form.setFieldsValue(formVals);
          if (formVals.scopeType === 2) {
            this.transferVal = formVals.scope;
          }
        });
      }
    },
    listResHandle (res) {
      res.forEach((el, index) => {
        let arr = [];
        el.android && arr.push('Android');
        el.ios && arr.push('iOS');
        el.platform = arr.join(' | ');
        el.isDefault = el.isDefault === 1 ? '是' : '否';
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>
